import Footer from "../components/Footer";
import Header from "../components/Header";

export default function About() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow h-full place-items-center px-5 sm:px-96 mb-40">
        <div className=" font-semibold text-xl">About Us</div>
        <div className="text-justify mt-5">
          The Mizoram Economic Association (MEA) is a purely academic,
          non-profit, and non-governmental organization established in 1992,
          with its General Headquarters in Aizawl, Mizoram. It is a registered
          society under Registration No. SR-72/93/MZ-RFS of 1993. Any person
          with a professional or academic interest in economics, or studying
          economics at the undergraduate level and above, is eligible to become
          a member of the Association upon payment of a nominal membership fee.
        </div>
        <div className="text-justify mt-2">
          The MEA aims to promote and encourage scientific research in
          economics, provide research inputs to address various economic and
          social issues facing society, and deliver credible public policy
          research to foster sustainable development in North Eastern India,
          particularly in the state of Mizoram.
        </div>
        <div className="mt-10 font-semibold text-xl">
          Office Bearers of the Mizoram Economic Association
        </div>
        <div className="mt-5 mb-20  w-full">
          <table
            style={{
              fontFamily: "arial, sans-serif",
              borderCollapse: "collapse",
              width: "100%",
            }}
          >
            <tbody>
              <tr>
                <td
                  style={{
                    border: "1px solid #dddddd",
                    textAlign: "left",
                    paddingTop: "10px",
                    paddingBottom: "10px",
                  }}
                  className="w-40 pl-2 font-semibold"
                >
                  President
                </td>
                <td
                  style={{
                    border: "1px solid #dddddd",
                    textAlign: "left",
                    paddingTop: "10px",
                    paddingBottom: "10px",
                    marginRight: "20px",
                  }}
                  className="w-96 pl-2"
                >
                  <div className="font-semibold">Dr. James L.T. Thanga</div>
                  <div className="">Professor</div>
                  <div className="">
                    Department of Economics, Mizoram University
                  </div>
                  <div className="">Aizawl; Mizoram-796004</div>
                  <div className="">
                    <a
                      href="mailto:jametea@yahoo.com"
                      className="hover:text-indigo-500"
                    >
                      jametea@yahoo.com
                    </a>
                  </div>
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    border: "1px solid #dddddd",
                    textAlign: "left",
                    paddingTop: "10px",
                    paddingBottom: "10px",
                  }}
                  className="w-40 pl-2 font-semibold"
                >
                  Vice President
                </td>
                <td
                  style={{
                    border: "1px solid #dddddd",
                    textAlign: "left",
                    paddingTop: "10px",
                    paddingBottom: "10px",
                    marginRight: "20px",
                  }}
                  className="w-96 pl-2"
                >
                  <div className=" font-semibold">Dr. Rohmingliani</div>
                  <div className="">Associate Professor</div>
                  <div className="">
                    Department of Economics, Govt. Hrangbana College
                  </div>
                  <div className="">Aizawl; Mizoram-796007</div>
                  <div className="">
                    <a
                      href="mailto:jessie@ghbc.edu.in"
                      className="hover:text-indigo-500"
                    >
                      jessie@ghbc.edu.in
                    </a>
                  </div>
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    border: "1px solid #dddddd",
                    textAlign: "left",
                    paddingTop: "10px",
                    paddingBottom: "10px",
                  }}
                  className="w-40 pl-2 font-semibold"
                >
                  General Secretary
                </td>
                <td
                  style={{
                    border: "1px solid #dddddd",
                    textAlign: "left",
                    paddingTop: "10px",
                    paddingBottom: "10px",
                    marginRight: "20px",
                  }}
                  className="w-96 pl-2"
                >
                  <div className=" font-semibold">Dr. Daniel Lalawmpuia</div>
                  <div className="">Asst. Professor</div>
                  <div className="">
                    Department of Economics, Pachhunga University College
                  </div>
                  <div className="">Aizawl; Mizoram-796005</div>
                  <div className="">
                    <a
                      href="mailto:danielvarte12@gmail.com"
                      className="hover:text-indigo-500"
                    >
                      danielvarte12@gmail.com
                    </a>
                  </div>
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    border: "1px solid #dddddd",
                    textAlign: "left",
                    paddingTop: "10px",
                    paddingBottom: "10px",
                  }}
                  className="w-40 pl-2 font-semibold"
                >
                  Asst. Secretary
                </td>
                <td
                  style={{
                    border: "1px solid #dddddd",
                    textAlign: "left",
                    paddingTop: "10px",
                    paddingBottom: "10px",
                    marginRight: "20px",
                  }}
                  className="w-96 pl-2"
                >
                  <div className=" font-semibold">Dr. Joseph Lalremsanga</div>
                  <div className="">
                    Ramhlun North, Aizawl, Mizoram – 796012
                  </div>

                  <div className="">
                    <a
                      href="mailto:joseph@iumizoram.edu.in"
                      className="hover:text-indigo-500"
                    >
                      joseph@iumizoram.edu.in
                    </a>
                  </div>
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    border: "1px solid #dddddd",
                    textAlign: "left",
                    paddingTop: "10px",
                    paddingBottom: "10px",
                  }}
                  className="w-40 pl-2 font-semibold"
                >
                  Treasurer
                </td>
                <td
                  style={{
                    border: "1px solid #dddddd",
                    textAlign: "left",
                    paddingTop: "10px",
                    paddingBottom: "10px",
                    marginRight: "20px",
                  }}
                  className="w-96 pl-2"
                >
                  <div className=" font-semibold">Dr. K. Vanrammawia</div>
                  <div className="">Asst. Professor</div>
                  <div className="">
                    Department of Economics, Govt. Aizawl College
                  </div>
                  <div className="">Aizawl; Mizoram-796005</div>
                  <div className="">
                    <a
                      href="mailto:vkhiangte5@gmail.com"
                      className="hover:text-indigo-500"
                    >
                      vkhiangte5@gmail.com
                    </a>
                  </div>
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    border: "1px solid #dddddd",
                    textAlign: "left",
                    paddingTop: "10px",
                    paddingBottom: "10px",
                  }}
                  className="w-40 pl-2 font-semibold"
                >
                  Financial Secretary
                </td>
                <td
                  style={{
                    border: "1px solid #dddddd",
                    textAlign: "left",
                    paddingTop: "10px",
                    paddingBottom: "10px",
                    marginRight: "20px",
                  }}
                  className="w-96 pl-2"
                >
                  <div className=" font-semibold">Lalmalsawmi Renthlei</div>
                  <div className="">Associate Professor</div>
                  <div className="">Govt. Johnson College</div>
                  <div className="">Aizawl, Mizoram-796001</div>
                  <div className="">
                    <a
                      href="mailto:mycerenthlei63@gmail.com"
                      className="hover:text-indigo-500"
                    >
                      mycerenthlei63@gmail.com
                    </a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
          <div className="mt-10 font-semibold text-xl">
          Executive Committee Members
        </div>
        <div className="mt-5 mb-20  w-full">
          <table
            style={{
              fontFamily: "arial, sans-serif",
              borderCollapse: "collapse",
              width: "100%",
            }}
          >
            <tbody>
              <tr>
                <td
                  style={{
                    border: "1px solid #dddddd",
                    textAlign: "left",
                    paddingTop: "10px",
                    paddingBottom: "10px",
                    marginRight: "20px",
                    justifyItems:"center"
                  }}
                  className="w-96 pl-2"
                >
                  <div className="font-semibold">Prof. Vanlalchhawna</div>
                  <div className="">
                    Mizoram University
                  </div>
                </td>
              </tr>
                <tr>
                <td
                  style={{
                    border: "1px solid #dddddd",
                    textAlign: "left",
                    paddingTop: "10px",
                    paddingBottom: "10px",
                    marginRight: "20px",
                    justifyItems:"center"
                  }}
                  className="w-96 pl-2"
                >
                  <div className="font-semibold">Dr. Lalchhuanmawia</div>
                  <div className="">
                    Government T. Romana College
                  </div>
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    border: "1px solid #dddddd",
                    textAlign: "left",
                    paddingTop: "10px",
                    paddingBottom: "10px",
                    marginRight: "20px",
                    justifyItems:"center"
                  }}
                  className="w-96 pl-2"
                >
                  <div className="font-semibold">Mr. Lalthlamuana Ralte</div>
                  <div className="">
                    Pachhunga University College
                  </div>
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    border: "1px solid #dddddd",
                    textAlign: "left",
                    paddingTop: "10px",
                    paddingBottom: "10px",
                    marginRight: "20px",
                    justifyItems:"center"
                  }}
                  className="w-96 pl-2"
                >
                  <div className="font-semibold">Mr. Vanlalmawia</div>
                  <div className="">
                   Government Aizawl West College
                  </div>
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    border: "1px solid #dddddd",
                    textAlign: "left",
                    paddingTop: "10px",
                    paddingBottom: "10px",
                    marginRight: "20px",
                    justifyItems:"center"
                  }}
                  className="w-96 pl-2"
                >
                  <div className="font-semibold">Dr. Lalfakawmi</div>
                  <div className="">
                    Government Aizawl College
                  </div>
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    border: "1px solid #dddddd",
                    textAlign: "left",
                    paddingTop: "10px",
                    paddingBottom: "10px",
                    marginRight: "20px",
                    justifyItems:"center"
                  }}
                  className="w-96 pl-2"
                >
                  <div className="font-semibold">Dr C.Lalthantluangi</div>
                  <div className="">
                    Government Hrangbana College
                  </div>
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    border: "1px solid #dddddd",
                    textAlign: "left",
                    paddingTop: "10px",
                    paddingBottom: "10px",
                    marginRight: "20px",
                    justifyItems:"center"
                  }}
                  className="w-96 pl-2"
                >
                  <div className="font-semibold">Dr. Lianhmingthanga</div>
                  <div className="">
                    Government Aizawl North College
                  </div>
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    border: "1px solid #dddddd",
                    textAlign: "left",
                    paddingTop: "10px",
                    paddingBottom: "10px",
                    marginRight: "20px",
                    justifyItems:"center"
                  }}
                  className="w-96 pl-2"
                >
                  <div className="font-semibold">Dr. Juliet F. Lalzarzoliani</div>
                  <div className="">
                    ICFAI University, Mizoram
                  </div>
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    border: "1px solid #dddddd",
                    textAlign: "left",
                    paddingTop: "10px",
                    paddingBottom: "10px",
                    marginRight: "20px",
                    justifyItems:"center"
                  }}
                  className="w-96 pl-2"
                >
                  <div className="font-semibold">Lalrinfeli</div>
                  <div className="">
                    Government J. Thankima College
                  </div>
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    border: "1px solid #dddddd",
                    textAlign: "left",
                    paddingTop: "10px",
                    paddingBottom: "10px",
                    marginRight: "20px",
                    justifyItems:"center"
                  }}
                  className="w-96 pl-2"
                >
                  <div className="font-semibold">Mr. Neng Thianlala (MCS)</div>
                  <div className="">
                    PS, Adviser to CM, Handholding Policy
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </main>
      <Footer />
    </div>
  );
}
